import { createContext, useContext } from 'react';

/**
 * The element in the shared slide-over's header that holds a view's own actions, beside the
 * copy-link button. A view renders its buttons into it with `createPortal`; it is null outside
 * the shared slide-over, where the view keeps its actions in its own body.
 */
export const SlideOverHeaderActionsContext = createContext<HTMLElement | null>(
  null,
);

export const useSlideOverHeaderActions = () =>
  useContext(SlideOverHeaderActionsContext);
